import React from "react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";

const requestExamples = [
  "선호하는 간식/음료 품목 요청",
  "제외하고 싶은 품목 전달",
  "구성 방향이나 취향 의견 정리",
];

const SnackRequestPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-extrabold">요청하기</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          스낵매대 운영 관련 요청을 확인하고 정리하는 공간입니다.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>요청 메뉴 준비</CardTitle>
          <CardDescription>
            현재는 고객 계정 메뉴 구조를 먼저 추가한 상태입니다.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          <p>
            이후 이 영역에 요청 등록, 요청 내역 확인, 선호 품목 정리 같은 기능을
            연결할 수 있습니다.
          </p>
          <div className="space-y-2">
            <div className="font-semibold text-foreground">예상 요청 항목</div>
            <ul className="list-disc space-y-1 pl-5">
              {requestExamples.map((example) => (
                <li key={example}>{example}</li>
              ))}
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SnackRequestPage;
